export const testId = (name: string[]) =>
  name.join('-').toLowerCase().replaceAll('_', '-').replaceAll(' ', '-');

export default testId;
